import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import FilterPopover from 'talent_matching/components/filters/filter_popover';
import { useAdvancedFiltersContext } from 'talent_matching/contexts/advanced_filters_context';

const t = withLocalePrefix('talent_matching.filter_row.advanced_filters');

const AdvancedFiltersGroup = () => {
  const { filterGroups } = useAdvancedFiltersContext();

  return (
    <FilterPopover
      fieldName="advancedFilters"
      title={t('title')}
      getButtonLabel={(count: number) => t('button', { count })}
      addLabel={t('add_filter')}
      clearLabel={t('clear')}
      typeOptions={filterGroups}
    />
  );
};

export default AdvancedFiltersGroup;
